/* ============================================================
   SOLVEY · VIP Member Benefits card
   ------------------------------------------------------------
   Injecteert één "VIP Member Benefits"-card onderaan de Firmhouse
   Subscribe & Save card (.card-content) op alle PDP's. Zelfde
   resilience-pattern als de solvey-*-bullets.js scripts:
   - body-class-onafhankelijk; werkt op elke PDP met een
     .selling_plan_app_container
   - MutationObserver + retry want Firmhouse rendert (en re-rendert)
     ná DOMContentLoaded
   - Eigen i18n (Weglot ziet Firmhouse-injected content niet
     betrouwbaar) — mirror van solvey-firmhouse-i18n.js aanpak
   ============================================================ */
(function () {
  'use strict';

  var LANGS = {
    heading: {
      en: 'VIP Member Benefits',
      nl: 'VIP-ledenvoordelen',
      de: 'VIP-Mitgliedervorteile',
      da: 'VIP-medlemsfordele',
      fr: 'Avantages membres VIP'
    },
    body: {
      en: 'Be the first to hear about new launches, exclusive offers and subscriber-only gifts.',
      nl: 'Ontvang als eerste nieuwe launches, exclusieve aanbiedingen en cadeaus alleen voor abonnees.',
      de: 'Erfahre als Erste von neuen Launches, exklusiven Angeboten und Geschenken nur für Abonnenten.',
      da: 'Vær den første til at høre om nye lanceringer, eksklusive tilbud og gaver kun for abonnenter.',
      fr: 'Soyez la première informée des nouveautés, offres exclusives et cadeaux réservés aux abonnés.'
    }
  };

  var CROWN =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/>' +
    '<path d="M5 21h14"/>' +
    '</svg>';

  // Append aan de li (binnen de groene rand) i.p.v. .card-content: .card-content
  // is ingesprongen voorbij het radio-bolletje, waardoor de VIP-card links méér
  // padding kreeg dan rechts. De li-content-box geeft symmetrische 16px links+rechts.
  var TARGET_SELECTOR = '.selling_plan_app_container li.subscription-card';
  var ROOT_SELECTOR = '.selling_plan_app_container';
  var FLAG = 'data-solvey-vip';

  function currentLang() {
    if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
      var l = window.Weglot.getCurrentLang();
      if (l) return String(l).toLowerCase().split('-')[0];
    }
    if (window.Shopify && window.Shopify.locale) return String(window.Shopify.locale).toLowerCase().split('-')[0];
    if (document.documentElement.lang) return String(document.documentElement.lang).toLowerCase().split('-')[0];
    return 'nl';
  }

  function t(group, lang) {
    return LANGS[group][lang] || LANGS[group].en;
  }

  function buildCard(lang) {
    var card = document.createElement('div');
    card.className = 'solvey-vip-card';
    card.setAttribute(FLAG, 'true');
    card.innerHTML =
      '<div class="solvey-vip-card__sparkles" aria-hidden="true">' +
        '<span class="solvey-vip-card__sparkle solvey-vip-card__sparkle--1">&#10022;</span>' +
        '<span class="solvey-vip-card__sparkle solvey-vip-card__sparkle--2">&#10022;</span>' +
      '</div>' +
      '<div class="solvey-vip-card__text">' +
        '<div class="solvey-vip-card__heading">' + t('heading', lang) + '</div>' +
        '<div class="solvey-vip-card__body">' + t('body', lang) + '</div>' +
      '</div>' +
      '<div class="solvey-vip-card__badge wg-notranslate" data-wg-notranslate aria-hidden="true">' +
        CROWN +
        '<span class="solvey-vip-card__badge-vip">VIP</span>' +
        '<span class="solvey-vip-card__badge-member">MEMBER</span>' +
      '</div>';
    return card;
  }

  function updateText(card, lang) {
    var h = card.querySelector('.solvey-vip-card__heading');
    var b = card.querySelector('.solvey-vip-card__body');
    if (h && h.textContent !== t('heading', lang)) h.textContent = t('heading', lang);
    if (b && b.textContent !== t('body', lang)) b.textContent = t('body', lang);
  }

  function apply() {
    var lang = currentLang();
    var targets = document.querySelectorAll(TARGET_SELECTOR);
    for (var i = 0; i < targets.length; i++) {
      var existing = targets[i].querySelector('.solvey-vip-card[' + FLAG + '="true"]');
      if (existing) {
        updateText(existing, lang);
      } else {
        targets[i].appendChild(buildCard(lang));
      }
    }
  }

  var debounce;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(apply, 50);
  }

  function start() {
    apply();
    var root = document.querySelector(ROOT_SELECTOR);
    if (root && 'MutationObserver' in window) {
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    }
    if (window.Weglot && typeof window.Weglot.on === 'function') {
      try { window.Weglot.on('languageChanged', schedule); } catch (e) {}
    }
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Firmhouse rendert soms laat — retry kort + lang-poll voor late Weglot init.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    apply();
    if (tries > 24) clearInterval(timer);
  }, 250);
})();
